// Rebuy Quick View: lock page scroll while the search dropdown is open.
// The dropdown itself keeps its own overflow-y, so only the page behind freezes.
// Visibility is measured, not just presence, because Rebuy may toggle the
// dropdown with either v-if (node removed) or v-show (display: none).
(function () {
  const DROPDOWN_SEL = '.rebuy-quick-view-dropdown__container';
  const ROOT_SEL = '#rebuy-quick-view-dropdown-search';
  const LOCK_CLASS = 'rebuy-quick-view-open';

  let frame = null;
  let locked = false;
  let lastViewportHeight = null;

  function isVisible(el) {
    if (!el) return false;
    if (!el.getClientRects().length) return false;
    return getComputedStyle(el).visibility !== 'hidden';
  }

  // iOS Safari pans on touch regardless of overflow, and the soft keyboard makes it worse
  // Allowed anywhere in the search root, since the scroller is the container on desktop and the overlay on mobile
  function blockTouchScroll(event) {
    if (event.touches.length > 1) return;
    const target = event.target;
    if (target instanceof Element && target.closest(ROOT_SEL)) return;
    if (event.cancelable) event.preventDefault();
  }

  function setTouchLock(on) {
    if (on === locked) return;
    locked = on;
    if (on) {
      document.addEventListener('touchmove', blockTouchScroll, { passive: false });
    } else {
      document.removeEventListener('touchmove', blockTouchScroll, { passive: false });
    }
  }

  // The keyboard's own "scroll focused input into view" bypasses overflow: hidden
  // (that's why body is pinned with position: fixed at all) and pans the document's
  // scroll offset. That pan doesn't self-correct once the keyboard closes, and since
  // the dropdown is a fixed-position overlay, a stale offset leaves it visually
  // clipped/unscrollable even though nothing in our own lock changed.
  function onViewportResize() {
    if (!locked || !window.visualViewport) return;
    const height = window.visualViewport.height;
    if (lastViewportHeight !== null && height > lastViewportHeight + 40) {
      window.scrollTo(0, 0);
    }
    lastViewportHeight = height;
  }

  function sync() {
    frame = null;
    const open = isVisible(document.querySelector(DROPDOWN_SEL));
    if (open && !locked) {
      window.scrollTo(0, 0);
      lastViewportHeight = window.visualViewport ? window.visualViewport.height : null;
    }
    // html carries the lock too: base.css sets html overflow-x, so body overflow no longer propagates to the viewport
    document.documentElement.classList.toggle(LOCK_CLASS, open);
    document.body.classList.toggle(LOCK_CLASS, open);
    setTouchLock(open);
  }

  function scheduleSync() {
    if (frame !== null) return;
    frame = requestAnimationFrame(sync);
  }

  const observer = new MutationObserver(scheduleSync);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style'],
  });

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', onViewportResize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
